import { useState } from 'react'

import { Modal } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import useShareSheetV2 from 'hooks/useShareSheetV2'
import { TakeOwnershipConfirmationProps } from './Types'

export const TakeOwnershipConfirmation = ({ newOwnerId, file }: TakeOwnershipConfirmationProps) => {
  const { isMobile } = useResponsiveDesign()
  const fileType = file.type === 'article' ? 'document' : file.type
  const { transferOwnership, setShareSheet } = useShareSheetV2(file)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const goBack = () => {
    setShareSheet({ takeOwnership: false })
    setIsSubmitting(false)
  }

  const handleTransfer = () => {
    setIsSubmitting(true)
    transferOwnership({ id: newOwnerId, goBack })
  }

  return (
    <Modal.Root size={isMobile ? 'xs' : 'sm'}>
      <Modal.Header
        isConfirmation
        title="Take Ownership"
        subHeader={`The current owner might lose the ability to change this ${fileType}’s share settings. You can transfer your ownership to other members again.`}
      />
      <Modal.Footer isConfirmation>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="secondary" onPress={goBack}>
            Back
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button size="lg" onPress={handleTransfer} isDisabled={isSubmitting}>
            Take Ownership
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
